import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "max-w-[1600px] mx-auto" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center space-x-4" }
const _hoisted_5 = { class: "max-w-[1600px] mx-auto p-6" }

import { reactive, inject } from 'vue'
import { useRouter } from 'vue-router'
import { useTheme } from '../../utils/useTheme'
import ReportForm from './components/ReportForm.vue'
import Toast from '../../components/base/common/Toast.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'create',
  setup(__props) {

const theme = inject('theme', useTheme())
const router = useRouter()

// Toast
const toast = reactive({
  show: false,
  message: '',
  type: 'success' as 'success' | 'error'
})

const showToast = (message: string, type: 'success' | 'error') => {
  toast.message = message
  toast.type = type
  toast.show = true
}

const goBack = () => {
  router.push('/platform-report')
}

const handleSaved = () => {
  showToast('Report created successfully', 'success')
  setTimeout(() => {
    router.push('/platform-report')
  }, 1000)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4 shadow-sm-custom sticky top-0 z-10'
      ]),
      style: {"box-shadow":"var(--shadow-sm)"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200",
              onClick: goBack
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M10 19l-7-7m0 0l7-7m-7 7h18"
                })
              ], -1)
            ])),
            _createElementVNode("div", null, [
              _createElementVNode("h1", {
                class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-100' : 'text-gray-900',
                  'text-2xl font-bold'
                ])
              }, " Create New Report ", 2),
              _createElementVNode("p", {
                class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600', 'mt-1 text-sm'])
              }, " Configure HTTP source, template transform, and Slack destination ", 2)
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(ReportForm, {
        mode: "create",
        onSaved: handleSaved,
        onCancel: goBack
      })
    ]),
    _createVNode(Toast, {
      show: toast.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((toast.show) = $event)),
      message: toast.message,
      type: toast.type,
      duration: 4000
    }, null, 8, ["show", "message", "type"])
  ]))
}
}

})